@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    padding: 0 3%;
}

.form {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1em;
    margin-top: 2em;
    margin-bottom: 2em;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: repeat(2, 1fr);
    }
}

.sectionDivider {
    grid-column: 1 / span 4;
    border-bottom: 1px solid var(--color-black);
    margin-top: 2rem;
    margin-bottom: 2rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 2;
    }
}

.heading {
    font-size: 1.5rem;
    line-height: 1.1;
    margin-bottom: 1.875rem;
    text-transform: uppercase;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 6vw;
    }
}

.subheading {
    font-size: 1.25rem;
    line-height: 1.1;
    margin-bottom: 1.875rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 4vw;
    }
}

.mobileLabel {
    @include breakpoint.breakpoint(layout.$belowMedium) {
        & * {
            font-size: 5vw;
            white-space: break-spaces;
        }

        & textarea {
            height: 20rem;
        }
    }
}

.questionCategory,
.topic,
.visitLocation,
.visitDate,
.lastName,
.email,
.phone,
.addressLine1 {
    composes: mobileLabel;
    grid-column: span 2;
}

.dropdown {
    & select {
        background: linear-gradient(#e0f7fa, #80deea);
        border: none;
        box-shadow: 1px 1px 3px rgb(var(--color-black-base), 0.25);
        color: var(--color-lobster);
        cursor: pointer;

        &:hover {
            color: var(--color-black);
        }
    }
}

.questionCategory {
    composes: dropdown;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        & * {
            font-size: 4vw;
        }
    }
}

.topic {
    composes: dropdown;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        & * {
            font-size: 4vw;
        }
    }
}

.firstName {
    composes: mobileLabel;
    grid-column: 1 / span 2;
}

.addressCity {
    composes: mobileLabel;
    grid-column: 1 / span 2;
}

.visitTime {
    composes: mobileLabel;
    grid-column: 3 / span 1;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 1;
    }
}

.orderNumber {
    composes: mobileLabel;
    grid-column: 4 / span 1;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 2 / span 1;
    }
}

.addressState,
.addressZip {
    composes: mobileLabel;
    grid-column: span 1;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: span 2;
    }
}

.message {
    composes: mobileLabel;
    grid-column: 1 / span 4;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 2;
    }
}

.captcha {
    grid-column: 1 / span 4;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 2;
    }
}

.actions {
    grid-column: 1 / span 4;
    text-align: center;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 2;
    }
}

.send {
    composes: button from "../../styles/buttons.module.scss";
}
